import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { HttpResponseSuccess } from '@/services/service';
import {
	getOnboardingScore,
	GetOnboardingScoringResponse
} from '@/services/onboardingLeadScore';

export const useGetOnboardingScore = (): UseMutationResult<
	HttpResponseSuccess<GetOnboardingScoringResponse>,
	Error
> => {
	return useMutation({
		mutationFn: getOnboardingScore,
		onError: error => {
			throw new Error('Error retrieving user onboarding:', error);
		}
	});
};
